<template>
  <div class="local-scroller padding-right-5 card-col" @scroll="updateScroll">
    <div class="dynamic-list-pla">
      <div :style="{ marginBottom: lstMarginBtm + 'px', marginTop: lstMarginTop + 'px' }">
        <PlagiarismCard
          v-for="(plagiarism_result, index) in data.slice(from, to)"
          :key="index"
          :plagiarism_result="plagiarism_result"
          :ignoringSourceList="version.ignoredSimilarSources"
          :index="plagiarism_result.id"
          :is-group-result="isGroupResult"
          @excludeLink="updateExcludeLinkList($event)"
        />
      </div>
      <div class="blank-div"></div>
    </div>
  </div>
</template>

<script>
import PlagiarismCard from '@/components/ResultDocument/PlagiarismCard'
import { DocumentTypes } from '@/constants/DoITConstant'

export default {
  name: 'PlagiarismCardList',
  props: {
    data: {
      type: Array,
      required: true,
    },
    version: {
      type: Object,
      required: true,
    },
  },
  components: {
    PlagiarismCard,
  },
  data: () => {
    // 154: height, 25: margin bottom
    const ITEM_HEIGHT = 154 + 25

    return {
      itemHeight: ITEM_HEIGHT,
      elHeight: 0,
      scrollTop: 0,
      from: 0,
      to: 5,
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.initList)
  },
  mounted() {
    window.addEventListener('resize', this.initList, { passive: true })
    this.initList()
  },
  methods: {
    initList() {
      this.elHeight = this.$el.getBoundingClientRect().height
      this.updateFromTo()
    },
    updateExcludeLinkList(data) {
      this.$emit('exclude-link-list', data)
    },
    updateScroll(e) {
      this.scrollTop = e.target.scrollTop
      this.updateFromTo()
    },
    updateFromTo() {
      this.from = Math.floor(this.scrollTop / this.itemHeight)
      this.to = Math.ceil((this.scrollTop + this.elHeight - 5) / this.itemHeight)
    },
    sourcesListHeight(numberOfSource) {
      if (numberOfSource >= 5) {
        return 445
      } else {
        return 80 * numberOfSource + 15
      }
    },
    scrollToItem(itemId) {
      this.$el.scrollTo(0, (itemId - 1) * this.itemHeight)
    },
  },
  computed: {
    lstMarginTop() {
      return this.from * this.itemHeight
    },
    lstMarginBtm() {
      return (this.data.length - this.to) * this.itemHeight
    },
    isGroupResult() {
      console.log('group type check: ', this.$route.params.type === DocumentTypes.GROUP_DOCUMENT)
      return this.$route.params.type === DocumentTypes.GROUP_DOCUMENT
    }
  },
}
</script>

<style scoped>
.card-col {
  height: 100%;
  position: relative;
}

.dynamic-list-pla {
  height: 100%;
  width: 99%;
  position: absolute;
  top: 0;
}

.blank-div {
  height: 1px;
  width: 100%;
}
</style>
